import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-emerald-950 py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-4 md:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-emerald-400 hover:text-emerald-300 text-sm font-inter mb-6 transition-colors">
            <i className="ri-arrow-left-line" />
            Voltar ao início
          </Link>
          <h1 className="font-sora font-bold text-3xl md:text-4xl text-white">
            Política de Privacidade
          </h1>
          <p className="font-inter text-emerald-100/60 text-sm mt-3">
            Última atualização: 17 de abril de 2026
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="prose prose-zinc max-w-none font-inter text-zinc-600 leading-relaxed [&_h2]:font-sora [&_h2]:font-bold [&_h2]:text-zinc-900 [&_h2]:text-xl [&_h2]:mt-10 [&_h2]:mb-4 [&_p]:mb-4 [&_ul]:mb-4 [&_li]:mb-1.5 [&_a]:text-emerald-600 [&_a]:underline [&_strong]:text-zinc-800">

          <p>
            Esta Política de Privacidade descreve como a <strong>Almadata Soluções Tecnológicas</strong> coleta, utiliza e protege suas informações ao acessar nosso site e utilizar nossos serviços.
          </p>

          <h2>1. Quem somos</h2>
          <p>
            Somos a Almadata Soluções Tecnológicas, especializada em consultoria estratégica de negócios, engenharia de software e inteligência artificial aplicada. Para dúvidas sobre privacidade, entre em contato pelo e-mail <a href="mailto:contato@almadata.com.br">contato@almadata.com.br</a>.
          </p>

          <h2>2. Dados coletados</h2>
          <p>Podemos coletar os seguintes dados:</p>
          <ul>
            <li>Nome, e-mail, telefone, empresa e setor de atuação — fornecidos voluntariamente via formulário de contato;</li>
            <li>Descrição do problema ou necessidade de negócio informada no formulário;</li>
            <li>Dados de navegação (páginas visitadas, tempo de permanência) para melhoria contínua do site;</li>
            <li>Endereço IP e informações do navegador para segurança e análise agregada.</li>
          </ul>

          <h2>3. Uso das informações</h2>
          <p>Utilizamos seus dados para:</p>
          <ul>
            <li>Responder a solicitações de contato e propostas comerciais;</li>
            <li>Qualificar oportunidades de negócio e agendar reuniões;</li>
            <li>Enviar comunicações sobre serviços, quando autorizado;</li>
            <li>Melhorar a experiência de navegação e o conteúdo do site;</li>
            <li>Cumprir obrigações legais e regulatórias.</li>
          </ul>

          <h2>4. Compartilhamento com terceiros</h2>
          <p>
            Não vendemos, alugamos ou compartilhamos seus dados pessoais com terceiros para fins de marketing. Podemos utilizar serviços de terceiros para hospedagem, análise e comunicação (como provedores de e-mail e ferramentas de analytics), que processam dados conforme suas próprias políticas de privacidade e sob obrigações contratuais de confidencialidade.
          </p>

          <h2>5. Segurança</h2>
          <p>
            Adotamos medidas técnicas e organizacionais para proteger suas informações, incluindo criptografia em trânsito (HTTPS), controle de acesso restrito e monitoramento de vulnerabilidades. Nenhum sistema é 100% seguro — caso identifique qualquer vulnerabilidade, entre em contato imediatamente.
          </p>

          <h2>6. Direitos do titular</h2>
          <p>
            Conforme a LGPD, você tem direito a:
          </p>
          <ul>
            <li>Solicitar acesso aos seus dados pessoais;</li>
            <li>Corrigir dados incompletos, inexatos ou desatualizados;</li>
            <li>Solicitar a exclusão de seus dados pessoais;</li>
            <li>Revogar consentimento a qualquer momento;</li>
            <li>Solicitar portabilidade dos dados.</li>
          </ul>
          <p>
            Para exercer qualquer desses direitos, envie um e-mail para <a href="mailto:contato@almadata.com.br">contato@almadata.com.br</a>.
          </p>

          <h2>7. Cookies</h2>
          <p>
            Utilizamos cookies essenciais para o funcionamento do site e cookies de análise para entender padrões de navegação. Você pode desativá-los nas configurações do seu navegador, mas algumas funcionalidades podem ser impactadas.
          </p>

          <h2>8. Retenção de dados</h2>
          <p>
            Dados de contato são mantidos enquanto houver relacionamento comercial ativo ou interesse legítimo. Dados de navegação são retidos de forma agregada e anonimizada. Após solicitação de exclusão, seus dados pessoais são removidos em até 30 dias úteis.
          </p>

          <h2>9. Alterações nesta política</h2>
          <p>
            Podemos atualizar esta política periodicamente. As alterações serão publicadas nesta página com data revisada. Recomendamos revisão periódica.
          </p>

          <h2>10. Contato</h2>
          <p>
            Para dúvidas ou solicitações sobre esta Política de Privacidade, entre em contato pelo e-mail <a href="mailto:contato@almadata.com.br">contato@almadata.com.br</a> ou pelo telefone +55 (61) 99223-2205.
          </p>

          <p>
            Esta Política está em conformidade com a <strong>Lei Geral de Proteção de Dados (LGPD — Lei 13.709/2018)</strong>.
          </p>

        </div>
      </div>
    </div>
  );
}
